import * as React from "react";
import DropDown from "components/DropDown";
import { makeStyles, createStyles, TextField, Theme } from "@material-ui/core";
import config from "customConfig";

export interface SpeakingControlProps {
  input: any;
  handleInputChange: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputContainer: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
  })
);

const SpeakingControl: React.FC<SpeakingControlProps> = ({
  input,
  handleInputChange,
}) => {
  const classes = useStyles();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    handleInputChange("search")(value);
  };
  return (
    <div>
      <div className={classes.inputContainer}>
        <DropDown
          name="Format"
          options={config.speakingTypeName}
          value={input.typeName}
          setValue={handleInputChange("typeName")}
        />
        <TextField
          label="Search by ID"
          type="search"
          variant="outlined"
          name="search"
          autoComplete="off"
          value={input.search ?? ""}
          onChange={handleChange}
          className={classes.formControl}
        />
      </div>
      <div className={classes.inputContainer}>
        <DropDown
          name="Season"
          options={config.seasons}
          value={input.season}
          setValue={handleInputChange("season")}
          noneValue
        />
        {input.typeName === "PartTwo" && (
          <DropDown
            name="Part2 Type"
            options={config.speakingPartTwoType}
            value={input.type}
            setValue={handleInputChange("type")}
            noneValue
          />
        )}
        {input.typeName === "PartOne" && (
          <DropDown
            name="Type"
            options={config.partOneType.map((type: string) => ({
              label: type,
              value: type,
            }))}
            value={input.type}
            setValue={handleInputChange("type")}
            noneValue
          />
        )}
        {input.typeName === "PartThree" && (
          <DropDown
            name="Type"
            options={config.partThreeType.map((type: string) => ({
              label: type,
              value: type,
            }))}
            value={input.type}
            setValue={handleInputChange("type")}
            noneValue
          />
        )}
      </div>
    </div>
  );
};

export default SpeakingControl;
